import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import {
  Box,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { EventDetailHostItem } from "./EventDetailHostItem";
import { EventDetailHosts$key } from "./__generated__/EventDetailHosts.graphql";

type EventDetailHostsProps = {
  fragmentRef: EventDetailHosts$key | null;
};

export const EventDetailHosts = ({ fragmentRef }: EventDetailHostsProps) => {
  const data = useFragment(EventDetailHostsFragment, fragmentRef);

  if (data === null || data?.event?.hostsVisible === false) {
    return null;
  }

  const hosts = data?.event?.hosts?.edges?.map((hostEdge) => {
    const host = hostEdge?.node;

    return (
      <EventDetailHostItem
        key={`host-${host?.id}`}
        fullName={host?.user?.fullName || ""}
        firstName={host?.user?.firstName || ""}
        lastName={host?.user?.lastName || ""}
        profileImageId={host?.profileImage?.publicId}
        color={data?.event?.eventSeries?.color ?? null}
      />
    );
  });

  return hosts?.length ? (
    <Box width="100%" mt={{ base: 6, lg: 4 }}>
      <Text
        variant="mainSmallSemiBold"
        color="text-primary"
        py={2}
      >{t`Hosted by`}</Text>
      <VStack>{hosts}</VStack>
    </Box>
  ) : null;
};

export const EventDetailHostsFragment = graphql`
  fragment EventDetailHosts on EventSession {
    event {
      hostsVisible
      eventSeries {
        color
      }
      hosts {
        edges {
          node {
            id
            user {
              firstName
              lastName
              fullName
            }
            profileImage {
              # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
              publicId: renderingKey
            }
          }
        }
      }
    }
  }
`;
